"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var material_1 = require("@mui/material");
var isEqual_1 = __importDefault(require("lodash/isEqual"));
var react_1 = __importDefault(require("react"));
var ScrollDiv_1 = __importDefault(require("components/Layout/ScrollDiv"));
var TransactionPopupCard_1 = require("../styles/TransactionPopupCard");
var MonthSummary_1 = __importDefault(require("./MonthSummary"));
var TransactionSummary_1 = __importDefault(require("./TransactionSummary"));
var TransactionPopup = function (_a) {
    var serviceStat = _a.serviceStat, onClose = _a.onClose;
    var _b = __read(react_1.default.useState(undefined), 2), selectedMonth = _b[0], setSelectedMonth = _b[1];
    return ((0, jsx_runtime_1.jsx)(material_1.ClickAwayListener, __assign({ onClickAway: onClose }, { children: (0, jsx_runtime_1.jsx)(TransactionPopupCard_1.TransactionPopupCard, { children: (0, jsx_runtime_1.jsx)(ScrollDiv_1.default, __assign({ style: { height: '100%' }, viewStyle: { position: 'inherit' } }, { children: (0, jsx_runtime_1.jsxs)(material_1.Box, __assign({ px: 1.5, py: 1, maxWidth: 535, maxHeight: 450 }, { children: [(0, jsx_runtime_1.jsx)(MonthSummary_1.default, { serviceStats: serviceStat, onMonthClick: function (yM) { return setSelectedMonth((0, isEqual_1.default)(selectedMonth, yM) ? undefined : yM); }, selectedMonth: selectedMonth }), (0, jsx_runtime_1.jsx)(material_1.Box, __assign({ mt: 2 }, { children: (0, jsx_runtime_1.jsx)(TransactionSummary_1.default, { serviceStat: serviceStat, yearMonth: selectedMonth }) }))] })) })) }) })));
};
exports.default = TransactionPopup;
